// extracted by mini-css-extract-plugin
export default {"page":"AnalyticsPage_page__SS9kY"};